import React, { FC } from "react";
import { Table, Tooltip } from "antd";
import { RouterParamType } from "@/model/navModel";
import { YhBox } from "@/components/YhBox";
import { useBmsBusSoDetailModel } from "../bmsBillBusSoModel"
import { ISaleDetailsList } from "../bmsBillBusSoType";
import { ColumnsType } from "antd/es/table";
export const TableBox: FC<RouterParamType> = ({ id, mode, IFormRef }) => {
    const { detailMaterialLookList, } = useBmsBusSoDetailModel();
    const MaterialColumns: ColumnsType<ISaleDetailsList> = [
        {
            title: '序号',
            width: 60,
            fixed: "left",
            render: (t: any, r: any, i: number) => i + 1
        }, {
            title: '公交编码',
            width: 120,
            dataIndex: 'materialNo',
            fixed: "left",
            render: (text: any, record: any, index: number) => <Tooltip placement="topLeft" title={text}><p className="ellipsis click-span">{text}</p></Tooltip>,
        }, {
            title: '商品编码',
            width: 120,
            dataIndex: 'materialCode',
            fixed: "left",
            // render: (text: any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,
            // render: (text: any, record: any, index: number) => <Tooltip placement="topLeft" title={text}><p className="ellipsis click-span" onClick={() => onHistoryModel(record)}>{text}</p></Tooltip>,
        }, {
            title: '替换编号',
            width: 160,
            dataIndex: 'replaceCode',
        }, {
            title: '商品名称',
            width: 160,
            dataIndex: 'materialName',
        }, {
            title: '仓库',
            width: 120,
            dataIndex: 'warehouseName',
        }, {
            title: '销售数量',
            width: 120,
            dataIndex: 'num',
        }, {
            title: '单价',
            width: 120,
            dataIndex: 'price',
        }, {
            title: '零件费',
            width: 120,
            dataIndex: 'partsCost',
        }, {
            title: '折扣',
            width: 120,
            dataIndex: 'discountRate',
            render: (text: string) => text + "%"
        }, {
            title: '总计',
            width: 120,
            dataIndex: 'amount',
        }, {
            title: '可用库存',
            width: 120,
            dataIndex: 'inventoryNum',
        }, {
            title: '品牌',
            width: 120,
            dataIndex: 'brandName',
        }, {
            title: '单位',
            width: 120,
            dataIndex: 'unitName',
        }, {
            title: '规格',
            width: 120,
            dataIndex: 'model',
        }, {
            title: '备注',
            width: 120,
            dataIndex: 'note',
        }
    ];

    return (
        <YhBox title="维修用料" style={{ marginBottom: "75px" }}>
            <Table
                rowKey={record => record.detailsId as string}
                rowClassName='editable-row yh-edit-table-tr'
                columns={MaterialColumns}
                dataSource={detailMaterialLookList}
                pagination={false}
                scroll={{ x: 'max-content', y: 300 }}
            />
        </YhBox>
    )
}